export enum IFrameSizeEventType {
  HEIGHT = 'Height',
}
